import React, { Component } from "react";
import {
  WithStyles,
  withStyles,
  Grid,
  Button,
  Link,
  Typography,
} from "@material-ui/core";
import { MyPATDialog, MyPATMultiSearch, MyPATToaster } from "../../common";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { axiosNTL } from "../../../services/axios";
import { Author, AuthorFromAPI, TypeOfAuthor } from "../types/ContentRequest";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setUserByRole } from "../actions/contentRequestActions";
import { getContentSubType } from "../../test-template/actions/testTemplateActions";
import {checkUserRoleMap, checkValidClientUser} from "../helpers/createContentRequest";
import _ from "lodash";
// import {getAuthorRole}from "../helpers/createContentRequest";
interface Props extends WithStyles<typeof ContentOwnersStyle> {
  onDone: (data: any) => void;
  onClose: () => void;
  authors: Author[];
  userRoleMap: any;
  setUserByRole:Function;
  otherQuestionData: any;
  currentAuthorData: string;
  lastAuthors: { [key: string]: AuthorFromAPI };
}

interface State {
  list: {
    creator: AuthorFromAPI[];
    evaluator: AuthorFromAPI[];
    languageEvaluator: AuthorFromAPI[];
    moderator: AuthorFromAPI[];
    publisher: AuthorFromAPI[];
  };
  authors: {
    creator?: Partial<Author>;
    evaluator?: Partial<Author>;
    languageEvaluator?: Partial<Author>;
    moderator?: Partial<Author>;
    publisher?: Partial<Author>;
  };
  prevAuthors:{
    creator?: Partial<Author>;
    evaluator?: Partial<Author>;
    languageEvaluator?: Partial<Author>;
    moderator?: Partial<Author>;
    publisher?: Partial<Author>;
  };
  error:any
}

class ContentAuthorsPopup extends Component<Props, State> {
  state: State = {
    list: {
      creator: [],
      evaluator: [],
      languageEvaluator: [],
      moderator: [],
      publisher: [],
    },
    authors: {},
    prevAuthors:{},
    error:{
      creator: {showError:false,errorText:''},
      evaluator: {showError:false,errorText:''},
      languageEvaluator:  {showError:false,errorText:''},
      moderator:  {showError:false,errorText:''},
      publisher:  {showError:false,errorText:''},
    }
  };
  constructor(){
    super();
    this.handleDoneBttn=this.handleDoneBttn.bind(this);
  }
  componentDidMount() {
    const { authors } = this.props;
    const authorDataByRole = authors.reduce((acc: any, author) => {
      if(!author.name.includes(author.client.name)) {
        author.name = `${author.name} | ${author.client.name}`
      }
      acc[author.type] = author;
      return acc;
    }, {});
    this.setState({ authors: authorDataByRole,prevAuthors:authorDataByRole });
  }
  fetchAuthorsByRole = async ({ role, module, searchQuery }: any) => {
    try {
      const data = await axiosNTL
        .get("user/users-by-role", {
          params: { role, module, searchQuery },
        })
        .then((res: any) => res.responseObject);

      const { users } = data;
      return users.map(({ _id, firstName, lastName, clientDetails }: any) => (
         {
        id: _id,
        name: `${firstName} ${lastName} | ${clientDetails.name}`,
        client:{name:clientDetails.name,id:clientDetails._id}
      }));
    } catch (error) {
      console.log(error);
    }
    return [];
  };
  handleAuthorSelection = (
    author: { name: string; id: string },
    authorType: TypeOfAuthor
  ) => {
    const {otherQuestionData, currentAuthorData} = this.props;
    const isValid= checkValidClientUser( this.state.authors, author, authorType, otherQuestionData, currentAuthorData);
    if(isValid) {
      this.setState((prevState) => {  
        const newAuthors = { ...prevState.authors };
        newAuthors[authorType] = {
          ...author,
          type: authorType,
          assignedDate: new Date().toISOString(),
        };
        const error={ ...this.state.error};
        error[authorType]={showError:false,errorText:''}
        this.setState({error})
        return {
          ...prevState,
          authors: newAuthors,
        };
      });
    } else {
      const error={ ...this.state.error};
      error[authorType]={showError:true,errorText:`Authors from different clients cannot be mapped in a subject`}
      this.setState({error})
    }

  };
  getSearchResult = async (searchQuery: string, authorType: TypeOfAuthor) => {
    let data: AuthorFromAPI[] = [];
    if (searchQuery) {
      data = await this.fetchAuthorsByRole({
        searchQuery,
        module: "question",
        role: authorType,
      });
    }
    this.setState((prevState) => {
      const newList = { ...prevState.list };
      newList[authorType] = data;
      return {
        ...prevState,
        list: newList,
      };
    });
  };
  handleResetBttn=()=>{
    this.setState({
      authors:{},
      error:{
        creator: {showError:false,errorText:''},
        evaluator: {showError:false,errorText:''},
        languageEvaluator:  {showError:false,errorText:''},
        moderator:  {showError:false,errorText:''},
        publisher:  {showError:false,errorText:''},
      }
    })
  }

  
  handleDoneBttn=(authors:any)=>{
     const{userRoleMap}=this.props;  
     const{prevAuthors}=this.state;
     const error={ ...this.state.error};
     const types = [
      "creator",
      "evaluator",
      "languageEvaluator",
      "moderator",
      "publisher",
    ];
    let newUserRoleMap={...userRoleMap}
    // first check in current Popup is anyone having more than 1 role
    const authorsTypeMap:any={};
    let moveForward=true;
    for(let i=0; i<types.length; i++){
      const authorId=_.get(authors,`${types[i]}.id`,"");
     if(_.isEmpty(authorId)){
       continue;
     } 
      if(authorsTypeMap.hasOwnProperty(authorId)){
        // console.log(`The selected ${authors[types[i]].type} is already defined as ${authorsTypeMap[authorId].type} in this request`);
        error[types[i]]={showError:true,errorText:`The selected ${authors[types[i]].type} is already defined as ${authorsTypeMap[authorId].type} in this request`}
        moveForward=false;
      }else{
        authorsTypeMap[authorId]=authors[types[i]];
        error[types[i]]={showError:false,errorText:''};
      }
    }
    if(!moveForward){
      this.setState({error});
      return ;
    }
    moveForward=true;
  //  In whole Request 
    for(let i=0; i<types.length; i++){
      const authorId=_.get(authors,`${types[i]}.id`,"");
      const prevAuthorId=_.get(prevAuthors,`${types[i]}.id`,"");
      const response=checkUserRoleMap({...newUserRoleMap},authorId,types[i],prevAuthorId);
      if(response.status==='error'){
        error[types[i]]={showError:true,errorText:response.msg};
        moveForward=false;
      }else{
        newUserRoleMap=response.userRoleMap;
      }
     }
     if(!moveForward){
      this.setState({error});
       return;
     } 
     this.props.setUserByRole(newUserRoleMap);
     this.props.onDone(authors); 
  }
  setLastAuthors = () => {
    const { lastAuthors } = this.props;
    this.setState({ authors: lastAuthors,prevAuthors:lastAuthors });
  }
  render() {
    const { classes, lastAuthors, onClose } = this.props;
    const { list, authors,error } = this.state;
    return (
      <MyPATDialog
        dialogOpen={true}
        dialogHasActions={true}
        isOverflowVisible={true}
        dialogHeading={
          <>
            <Grid container justify="flex-start" className={classes.HeadingMainContainer}>
              <Grid item xs={12} className={classes.AuthorHeading}>Add Content Author</Grid>
              <Grid item xs={12} className={[classes.AuthorSubHeading, classes.mtminus10].join(' ')}>
                Select authors responsible for creating, evaluating, moderating,
                publishing content respectively
              </Grid>
            </Grid>
          </>
        }
        isAlignCenter={false}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={onClose}
        isCustomBackground={false}
        isborderDialogAction={false}
        otherDialogProps={{
          fullWidth: true,
          maxWidth: 'md',
          scroll: 'body'
        }}
        customDialogActions={
          <>
            <Grid
              container
              justify="flex-end"
              spacing={24}
              alignItems="center"
              // className={classes.dialogActions}
            >
              <Grid item>
              <Button onClick={this.handleResetBttn.bind(this)}>Reset</Button>
              </Grid>
              <Grid item>
                <Button
                  // onClick={this.handleDialogClose.bind(this)}
                  // disabled={isDisableRepublishAll}
                  // className={classes.okButton}
                  variant="contained"
                  color="primary"
                  onClick={()=>{this.handleDoneBttn(authors)}}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
          </>
        }
      >
        {/* <Typography className={[classes.popupLabel, classes.marginTop16].join(' ')}>
            Select authors responsible for creating, evaluating, mderating,
            publishing content respectively
          </Typography> */}
        <Grid container className={[classes.dialogHeight,
        classes.transitionCSS].join(' ')}>
          {!_.isEmpty(lastAuthors) && (
            <div>
              <Button color="primary" onClick={this.setLastAuthors}>Copy last authors</Button>
            </div>
          )}
          <Grid container spacing={16}>
            <Grid item xs={6} className={classes.infoIconImgHide}>
              <Typography className={[classes.popupLabel].join(' ')}>
                Add Content Creator&nbsp;
                <CustomInfoIcon
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Content Creator"
                  dialogPara="Author under creator category has the responsibility to create questions on CMS and get it verified and approved by Evaluator/ Lang. Evaluator/ Moderator/ Publisher. It is mandatory to define a creator for content"
                  // imageURL={false}
                  htmlElement=""
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </Typography>
              <Grid className="searchTransition">
                {/* <img src="/assets/svg/userManagement/search-icon.svg" />
                <input type="text" placeholder="Add Client and user" /> */}
                <MyPATMultiSearch
                  options={list.creator}
                  labelKey="name"
                  valueKey="id"
                  onChange={this.handleAuthorSelection}
                  values={authors.creator}
                  isSearchAble
                  isCustomFilter
                  filtredFunction={this.getSearchResult}
                  name="creator"
                  placeholderText="Search Creator and add"
                  error={error.creator.showError}
                  errorText={error.creator.errorText}
                />
              </Grid>
            </Grid>

            <Grid item xs={6} className={classes.infoIconImgHide}>
              <Typography className={[classes.popupLabel].join(' ')}>
                Add Content Evaluator&nbsp;{" "}
                <CustomInfoIcon
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Content Evaluator"
                  dialogPara="Author under Evaluator category can evaluate the questions and provide feedback to the users under preceding category. He/She can also edit the content if needed. This category is optional."
                  // imageURL=""
                  htmlElement=""
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </Typography>
              <Grid className="searchTransition">
                <MyPATMultiSearch
                  options={list.evaluator}
                  labelKey="name"
                  valueKey="id"
                  onChange={this.handleAuthorSelection}
                  values={authors.evaluator}
                  isSearchAble
                  isCustomFilter
                  filtredFunction={this.getSearchResult}
                  name="evaluator"
                  placeholderText="Search Evaluator and add"
                  error={error.evaluator.showError}
                  errorText={error.evaluator.errorText}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.infoIconImgHide}>
            <Grid item xs={6}>
              <Typography className={[classes.popupLabel, classes.marginTop16].join(' ')}>
                Add Language Evaluator&nbsp;
                <CustomInfoIcon
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Language Evaluator"
                  dialogPara="Author under Language Evaluate category can evaluate language of the questions and provide feedback to the users under preceding category. He/She can also edit the content if needed. This category is optional."
                  // imageURL={false}
                  htmlElement=""
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </Typography>
              <Grid className="searchTransition">
                <MyPATMultiSearch
                  options={list.languageEvaluator}
                  labelKey="name"
                  valueKey="id"
                  onChange={this.handleAuthorSelection}
                  values={authors.languageEvaluator}
                  isSearchAble
                  isCustomFilter
                  filtredFunction={this.getSearchResult}
                  name="languageEvaluator"
                  placeholderText="Search Evaluator and add"
                  error={error.languageEvaluator.showError}
                  errorText={error.languageEvaluator.errorText}
                />
              </Grid>
            </Grid>

            <Grid item xs={6} className={classes.infoIconImgHide}>
              <Typography className={[classes.popupLabel, classes.marginTop16].join(' ')}>
                Add Content Moderator&nbsp;{" "}
                <CustomInfoIcon
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Content Moderator"
                  dialogPara="Author under Moderator category can moderate the questions and provide feedback to the users under preceding category. He/She can also edit the content if needed. This category is optional."
                  // imageURL={false}
                  htmlElement=""
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </Typography>
              <Grid className="searchTransition">
                <MyPATMultiSearch
                  options={list.moderator}
                  labelKey="name"
                  valueKey="id"
                  onChange={this.handleAuthorSelection}
                  values={authors.moderator}
                  isSearchAble
                  isCustomFilter
                  filtredFunction={this.getSearchResult}
                  name="moderator"
                  placeholderText="Search Moderator and add"
                  error={error.moderator.showError}
                  errorText={error.moderator.errorText}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16}>
            <Grid item xs={6} className={classes.infoIconImgHide}>
              <Typography className={[classes.popupLabel, classes.marginTop16].join(' ')}>
                Add Content Publisher&nbsp;
                <CustomInfoIcon
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Content Publisher"
                  dialogPara="Author under Publisher category can approve and publish the questions or provide feedback to the users under preceding category. He/She can also edit the content if needed. It is mandatory to define a publisher for the content"
                  // imageURL={false}
                  htmlElement=""
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </Typography>
              <Grid className="searchTransition">
                <MyPATMultiSearch
                  options={list.publisher}
                  labelKey="name"
                  valueKey="id"
                  onChange={this.handleAuthorSelection}
                  values={authors.publisher}
                  isSearchAble
                  isCustomFilter
                  filtredFunction={this.getSearchResult}
                  name="publisher"
                  placeholderText="Search Publisher and add" 
                  error={error.publisher.showError}
                  errorText={error.publisher.errorText}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MyPATDialog>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    userRoleMap: state.contentRequestReducer.contentRequestCreateReducer.userRoleMap,
  };
};
const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setUserByRole
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps)(withStyles(ContentOwnersStyle)(ContentAuthorsPopup));
